// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31hSS","badges":"styles_badges__Emihk"};